window.customElements.define("mobilemenu-nav", class MobileMenu extends HTMLElement {

  constructor() {

    super();

    this.isVisible = false;
    this.isSubmenuVisible = false;
    this.transitionTime = 300;
    this.animationStyle = null;
    this.mobilemenuEl = null;
    this.bodyEl = null;
    this.pageWrapEl = null;
    this.themeStyle = null;
    this.isHiddenClass = 'mobilemenu--hidden';
    this.isVisibleClass = 'mobilemenu--isVisible';
    this.isSubmenuVisibleClass = 'mobilemenu--isVisible-submenu';
    this.noScrollClass = 'pre-noscroll';
    this.isActiveClass = 'active';
    this.dropdownListTarget = '.mobilemenu__link[aria-expanded]';
    this.dropdownExpandedListTarget = '.mobilemenu__link[aria-expanded="true"]';
    this.tierActiveTarget = '.mobilemenu-tier.' + this.isActiveClass;
    this.linkTarget = '.mobilemenu__link';
    this.mobilemenuToggleTarget = '.mobilemenu-button';
  }

  connectedCallback() {
    this.mobilemenuEl = this.querySelector('mobilemenu-nav aside');
    this.pageWrapEl = document.querySelector('main-content');
    this.bodyEl = document.querySelector('body')
    this.themeStyle = this.bodyEl.getAttribute('id')
    this.setMobilemenuAnimationStyle();
    this.setMobilemenu();
    this.toggleButton = document.querySelector(this.mobilemenuToggleTarget);

    this.toggleButton.addEventListener('click', this.toggleButtonEventClick.bind(this));

    this.querySelectorAll('.has_submenu').forEach((link) => {
      link.addEventListener('click', () => {
        this.openDropdownList(link);
      });
    });

    document.addEventListener("cart drawer:opened", this.mobilemenuHide.bind(this));
    document.addEventListener("drawer:opened", this.mobilemenuHide.bind(this));

    this.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
      element.addEventListener('change', (event) => {
        event.target.form.submit();
      });
    });

  }

  disconnectedCallback() {
    // Remove classes
    this.pageWrapEl.classList.remove('active');
    this.pageWrapEl.classList.remove('mobilemenu--push-left');
    this.pageWrapEl.classList.remove('mobilemenu--push-right');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-left');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-right');
    this.pageWrapEl.classList.remove('mobilemenu--overlay-bottom');

    // Remove eventListeners
    this.toggleButton.removeEventListener('click', this.toggleButtonEventClick.bind(this));

    // Reset properties
    this.animationStyle = null;
  }

  setPositionFromTop() {
    let topPosition = 0;
    let header = document.querySelector('header');
    if (header) {
      topPosition += header.offsetHeight;
      topPosition += header.getBoundingClientRect().top;
    }

    let aside = document.querySelector('mobilemenu-nav aside');
    if (aside) {
      aside.style.top = topPosition + 'px';
    }
  }

  removeTopPositioning() {
    setTimeout(function() {
      let aside = document.querySelector('mobilemenu-nav aside');
      if (aside) {
        aside.style.top = '0px';
      }
    }, this.transitionTime)
  }

  // Methods
  mobilemenuHide() {
    this.mobilemenuEl.setAttribute('aria-expanded', 'false');
    this.classList.remove(this.isVisibleClass);
    this.bodyEl.classList.remove(this.isVisibleClass);
    this.pageWrapEl.classList.remove(this.isActiveClass);
    this.bodyEl.classList.remove(this.noScrollClass);
    this.bodyEl.classList.remove(this.isVisibleClass);
    this.isVisible = false;
    this.removeTopPositioning();
    if (this.isSubmenuVisible) {
      this.bodyEl.classList.remove(this.isSubmenuVisibleClass);
      this.querySelector('.mobile-submenu.active').classList.remove(this.isActiveClass);
      this.closeDropdownList();
    }
    document.dispatchEvent(new Event("mobilemenu:hidden"));
  }

  mobilemenuShow() {
    this.setPositionFromTop();
    this.mobilemenuEl.setAttribute('aria-expanded', 'true');
    this.classList.add(this.isVisibleClass);
    this.bodyEl.classList.add(this.isVisibleClass);
    this.pageWrapEl.classList.add(this.isActiveClass);
    this.bodyEl.classList.add(this.isVisibleClass);
    this.bodyEl.classList.add(this.noScrollClass);
    this.isVisible = true;
    document.dispatchEvent(new Event("mobilemenu:opened"));
  }

  toggleButtonEventClick() {
    this.btnToggle();
    this.mobilemenuToggle();
  }
  
  openDropdownList(link) {
    link.classList.toggle(this.isActiveClass);
    link.nextElementSibling.classList.toggle(this.isActiveClass);
    if (link.getAttribute('aria-expanded') == 'false') {
      link.setAttribute('aria-expanded', 'true');
      const dropdownListContent = link.nextElementSibling.querySelector('.mobile-submenu-wrap')
      let offset = dropdownListContent.offsetHeight + 30;
      link.nextElementSibling.style.maxHeight = `${offset}px`
    } else {
      link.nextElementSibling.style.maxHeight = 0
      link.setAttribute('aria-expanded', 'false');
    }
  }

  closeDropdownList() {
    if (this.querySelectorAll('.has_matching_tier.active')) {
      this.querySelectorAll('.has_matching_tier.active').forEach((link) => {
        link.classList.remove(this.isActiveClass);
        link.setAttribute('aria-expanded', 'false');
        link.nextElementSibling.style.maxHeight = 0;
        link.nextSibling.classList.remove(this.isActiveClass);
      });
    }
  }

  nextTier(tierEl) {
    if (!tierEl) return;

    tierEl.classList.add(this.isActiveClass);

    this.attachScrollingEventListener();
    this.setBackButton();
  }

  setBackButton() {
    if (!this.mobilemenuEl) return;
    const tierHeader = this.mobilemenuEl.querySelector('fostr-mobilemenu-header')
    const backButton = this.mobilemenuEl.querySelector('fostr-mobilemenu-button-back');

    if (!backButton) return false;

    if (this.mobilemenuEl.querySelectorAll(this.tierActiveTarget).length == 1) {
      backButton.classList.add(this.isHiddenClass);
      if (tierHeader) tierHeader.classList.add(this.isHiddenClass)
    } else {
      backButton.classList.remove(this.isHiddenClass);
      if (tierHeader) tierHeader.classList.remove(this.isHiddenClass)
    }

    return true;
  }

  btnToggle() {
    this.toggleButton.classList.toggle('open')
  }

  mobilemenuToggle() {
    if (!this.mobilemenuEl) return;

    if (!this.isVisible) {
      this.mobilemenuShow();
    }
    else {
      this.mobilemenuHide();
    }
  }

  setMobilemenuAnimationStyle() {
    if (!this.mobilemenuEl) return false;

    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--push-left')) ? 'push-left' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--push-right')) ? 'push-right' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-left')) ? 'overlay-left' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-right')) ? 'overlay-right' : this.animationStyle;
    this.animationStyle = (this.mobilemenuEl.classList.contains('mobilemenu--overlay-bottom')) ? 'overlay-bottom' : this.animationStyle;
  }

  isAnimationStylePush() {
    return (this.animationStyle === 'push-left' || this.animationStyle === 'push-right');
  }

  setMobilemenu() {
    if (!this.mobilemenuEl) return false;

    if (!this.pageWrapEl) {
      return;
    }

    this.pageWrapEl.classList.add('mobilemenu--' + this.animationStyle);
    this.classList.add('mobilemenu--' + this.animationStyle);

    return true;
  }

  attachScrollingEventListener() {
    if (!this.mobilemenuEl) return;

    let lastActiveTierEl = this.mobilemenuEl.querySelectorAll('.' + this.isActiveClass + ':not(.mobilemenu--watchingScroll)')[this.mobilemenuEl.querySelectorAll('.' + this.isActiveClass + ':not(.mobilemenu--watchingScroll)').length - 1];
    if (!lastActiveTierEl) return;

    let lastActiveTierBodyEl = lastActiveTierEl.querySelector('.mobilemenu-tier__body');
    if (!lastActiveTierBodyEl) return;

    lastActiveTierBodyEl.addEventListener('scroll',() => {
      if (!lastActiveTierBodyEl) return;

      if (lastActiveTierBodyEl.scrollTop > 0) {
        lastActiveTierEl.classList.add('mobilemenu--scrolling');
      }
      else {
        lastActiveTierEl.classList.remove('mobilemenu--scrolling');
      }
    }, {
      passive: true
    });

    lastActiveTierEl.classList.add('mobilemenu--watchingScroll');
  }
})
